<div class="overview-card-grid">
  <app-review-entry label="Employer Name" i18n-label [value]="employer?.name" />
  <app-review-entry label="Employer Short Name" i18n-label [value]="employer?.shortName" />
  <app-review-entry
    label="CRA Payroll Remittance Account Number"
    i18n-label
    [value]="employer?.craPayrollRemittanceAccountNumber" />
  <app-review-entry label="Entrance Date" i18n-label [value]="employer?.entranceDate | date : 'MMMM d, y'" />
</div>
